import React, { useState, useEffect, useRef } from "react";
import arrowLeft from "../../assets/arrow-left.svg";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Image,
  Card,
  Overlay,
  Popover,
  Row,
  Col,
  ListGroup,
  CloseButton,
} from "react-bootstrap";
import { toZonedTime } from "date-fns-tz";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useAppContext } from "../../AppContext";
import deleteIcon from "../../assets/delete.svg";
import { FaTrash } from "react-icons/fa"; // For delete icon
import Select from "react-select";
import Waitlist from "../../components/Modal/Waitlist";
import { FaRegCalendarAlt } from "react-icons/fa";
import productRoute from "../../services/productRoute";
import orderRoute from "../../services/orderRoute";
import { debounce } from "lodash";
import search from "../../assets/search.svg";
import useGoogleLoader from "../../hooks/useGoogleLoader";

export const supportedLGAs = [
  "Ifako-Ijaiye",
  "Eti-Osa",
  "Lagos Mainland",
  "Lagos Island",
  "Agege",
  "Somolu",
  "Ikeja",
  "Surulere",
  "Mushin",
  "Kosofe",
  "Magboro",
];

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const initialLgaOptions = [];

const CreateOrder = () => {
  const navigate = useNavigate();
  const { showToast } = useAppContext();
  const [deliveryStates, setDeliveryStates] = useState([]);
  const streetAddressRefs = useRef([]);
  const [orderDetails, setOrderDetails] = useState([
    {
      customerName: "",
      phoneNumber: "",
      email: "",
      items: [],
      boxes: [],
      deliveryType: "",
      deliveryDate: "",
      streetAddress: "",
      coordinates: [],
      state: "",
      LGA: "",
      landmark: "",
      recipientName: "",
      paymentType: "",
      orderComment: "",
      lgaOptions: [],
      originalLgaOptions: [],
      lgaLoading: false,
    },
  ]);

  // const [selectedItems, setSelectedItems] = useState([]);
  const popoverRefs = useRef([]);
  const popoverRefs2 = useRef([]);

  const [selectOptions, setSelectOptions] = useState([]);
  const [error, setError] = useState("");
  const googleLoader = useGoogleLoader();
  const [searchProduct, setSearchProduct] = useState("");
  const [showWaitlist, setShowWaitlist] = useState(false);
  const [globalProducts, setGlobalProducts] = useState([]);
  const [globalSubscriptions, setGlobalSubscriptions] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [boxesLoading, setBoxesLoading] = useState(false);
  const [statesLoading, setStatesLoading] = useState(false);

  const setLgaLoadingForIndex = (index, isLoading) => {
    setOrderDetails((prev) =>
      prev.map((item, idx) => (idx === index ? { ...item, lgaLoading: isLoading } : item))
    );
  };
  const [isFocused, setIsFocused] = useState(false);
  const { getGlobalProducts, getGlobalBoxes } = productRoute();
  const { createOrder, getOrderDeliveryLGAs, getDeliveryStates } = orderRoute();
  const stateDependencies = orderDetails.map((detail) => detail?.state);
  const [popoverStates, setPopoverStates] = useState(
    orderDetails.map(() => ({ isVisible: false, searchProduct: "", loading: false }))
  );
  const [popoverStates2, setPopoverStates2] = useState(
    orderDetails.map(() => ({ isVisible: false, loading: false }))
  );
  // const [selectedCategories, setSelectedCategories] = useState([]);
  // const [showDropdown, setShowDropdown] = useState({});
  // const [selectedItems, setSelectedItems] = useState({});
  // const [showAlert, setShowAlert] = useState({});
  const searchProducts = popoverStates.map((ps) => ps.searchProduct);
  const debouncedGetProducts = useRef([]);
  const previousSearchProducts = usePrevious(searchProducts) || [];

  const formatDate = (date) => {
    return date?.toLocaleDateString("en-CA", { timeZone: "Africa/Lagos" });
  };

  const readableDate = (date) => {
    return date?.toLocaleDateString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "Africa/Lagos",
    });
  };
  const NIGERIA_TZ = "Africa/Lagos";

  const getNigeriaTime = () => {
    const now = new Date();
    return toZonedTime(now, NIGERIA_TZ);
  };
  const calculateDays = (year, month, targetDay) => {
    let dates = [];
    let firstDay = new Date(year, month, 1);
    let dayOfWeek = firstDay.getDay();

    // Find the first occurrence of the target day
    let daysUntilTarget =
      dayOfWeek <= targetDay ? targetDay - dayOfWeek : 7 - (dayOfWeek - targetDay);
    let firstTargetDay = new Date(year, month, 1 + daysUntilTarget);

    // Collect up to 5 occurrences of that weekday
    for (let i = 0; i < 5; i++) {
      let nextDate = new Date(firstTargetDay);
      nextDate.setDate(firstTargetDay.getDate() + i * 7);
      if (nextDate.getMonth() === month) {
        dates.push(nextDate);
      }
    }

    return dates;
  };

  useEffect(() => {
    const updateOptions = () => {
      const today = getNigeriaTime();

      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const currentDay = today.getDay();
      const currentHour = today.getHours();

      const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

      let tuesdays = calculateDays(currentYear, currentMonth, 2); // Tuesday
      let thursdays = calculateDays(currentYear, currentMonth, 4); // Thursday
      let saturdays = calculateDays(currentYear, currentMonth, 6); // Saturday

      // Filter out past days
      tuesdays = tuesdays.filter((date) => startOfDay(date) > startOfDay(today));
      thursdays = thursdays.filter((date) => startOfDay(date) > startOfDay(today));
      saturdays = saturdays.filter((date) => startOfDay(date) > startOfDay(today));

      // Cutoff checks
      if (currentDay === 1 && currentHour >= 10) {
        // Monday after 10am — remove this week's Tuesday
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        tuesdays = tuesdays.filter((date) => startOfDay(date) > startOfDay(tomorrow));
      }

      if (currentDay === 3 && currentHour >= 10) {
        // Wednesday after 10am — remove this week's Thursday
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        thursdays = thursdays.filter((date) => startOfDay(date) > startOfDay(tomorrow));
      }

      if (currentDay === 5 && currentHour >= 10) {
        // Friday after 10am — remove this week's Saturday
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        saturdays = saturdays.filter((date) => startOfDay(date) > startOfDay(tomorrow));
      }

      // Ensure at least 4 dates per delivery day
      const fillDates = (daysArray, dayIndex) => {
        if (daysArray.length < 4) {
          const nextMonth = (currentMonth + 1) % 12;
          const nextYear = currentMonth + 1 > 11 ? currentYear + 1 : currentYear;
          const nextMonthDates = calculateDays(nextYear, nextMonth, dayIndex);
          return daysArray.concat(nextMonthDates.slice(0, 4 - daysArray.length));
        }
        return daysArray;
      };

      tuesdays = fillDates(tuesdays, 2);
      thursdays = fillDates(thursdays, 4);
      saturdays = fillDates(saturdays, 6);

      const options = [...tuesdays, ...thursdays, ...saturdays]
        .sort((a, b) => a - b)
        .map((date) => ({
          value: formatDate(date),
          label: readableDate(date),
        }));
      setSelectOptions(options);
    };

    updateOptions();
    let lastCheckedDay = null;

    const interval = setInterval(() => {
      const now = getNigeriaTime();
      const todayKey = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;

      if (lastCheckedDay === todayKey) return; // Avoid multiple updates on same day

      const hour = now.getHours();
      const day = now.getDay();

      const shouldUpdate =
        (day === 1 && hour >= 7) || // Monday
        (day === 3 && hour >= 7) || // Wednesday
        (day === 5 && hour >= 7); // Friday

      if (shouldUpdate) {
        updateOptions();
        lastCheckedDay = todayKey;
      }
    }, 60000); // every minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getDeliveryStates(showToast, setDeliveryStates, setStatesLoading);
  }, []);

  useEffect(() => {
    // Align popoverStates with orderDetails length
    if (popoverStates.length !== orderDetails.length) {
      setPopoverStates(
        orderDetails.map(() => ({ isVisible: false, searchProduct: "", loading: false }))
      );
    }
    if (popoverStates2.length !== orderDetails.length) {
      setPopoverStates2(orderDetails.map(() => ({ isVisible: false, loading: false })));
    }
  }, [orderDetails, popoverStates.length, popoverStates2.length]);

  useEffect(() => {
    // Adjust the length of the refs array to match the number of orderDetails
    popoverRefs.current = orderDetails.map(
      (_, index) => popoverRefs.current[index] || React.createRef()
    );
    popoverRefs2.current = orderDetails.map(
      (_, index) => popoverRefs2.current[index] || React.createRef()
    );
    streetAddressRefs.current = orderDetails.map(
      (_, index) => streetAddressRefs.current[index] || React.createRef()
    );
  }, [orderDetails.length]);

  useEffect(() => {
    getGlobalBoxes(setBoxesLoading, showToast, setGlobalSubscriptions);
  }, []);

  useEffect(() => {
    // Function to fetch LGAs for each order's state
    const fetchLGAsForOrders = () => {
      orderDetails.forEach((order, index) => {
        const selectedState = deliveryStates.find((state) => state?.name === order?.state);
        if (selectedState) {
          getOrderDeliveryLGAs(
            selectedState.id,
            showToast,
            orderDetails,
            setOrderDetails,
            index,
            (isLoading) => setLgaLoadingForIndex(index, isLoading)
          );
        }
      });
    };
    fetchLGAsForOrders();
  }, [deliveryStates, JSON.stringify(stateDependencies)]);

  useEffect(() => {
    // Re-initialize the debounced functions if the number of popovers changes
    debouncedGetProducts.current = popoverStates.map((_, index) =>
      debounce((searchProduct) => {
        getGlobalProducts(setProductsLoading, showToast, setGlobalProducts, searchProduct);
      }, 500)
    );

    return () => {
      // Cleanup by canceling all debounced calls
      debouncedGetProducts.current.forEach((fn) => fn.cancel());
    };
  }, [popoverStates.length]);

  useEffect(() => {
    // Only call API when there's an actual change in the search term
    searchProducts.forEach((searchProduct, index) => {
      if (searchProduct !== previousSearchProducts[index]) {
        if (searchProduct !== "") {
          debouncedGetProducts.current[index](searchProduct);
        } else {
          getGlobalProducts(setProductsLoading, showToast, setGlobalProducts);
        }
      }
    });
  }, [searchProducts]);
  useEffect(() => {
    const autocompleteInstances = [];

    googleLoader.load().then((google) => {
      orderDetails.forEach((detail, index) => {
        const inputRef = streetAddressRefs.current[index];
        if (inputRef?.current) {
          const autocomplete = new google.maps.places.Autocomplete(inputRef.current, {
            componentRestrictions: { country: "NG" },
          });

          const handlePlaceSelect = () => {
            const place = autocomplete.getPlace();
            const formattedAddress = place.formatted_address || "";
            const addressComponents = place.address_components;
            const location = place.geometry?.location;

            const normalizeStateName = (stateName) => {
              const stateMap = {
                Lagos: ["Lagos", "Ìpínlẹ̀ Èkó", "Lagos State"],
                Ogun: ["Ogun", "Ìpínlẹ̀ Ògùn", "Ogun State"],
              };
              for (const [key, values] of Object.entries(stateMap)) {
                if (values.includes(stateName)) return key;
              }
              return stateName;
            };

            const stateLongName = addressComponents.find((c) =>
              c.types.includes("administrative_area_level_1")
            )?.long_name;
            const normalizedStateName = normalizeStateName(stateLongName);

            if (normalizedStateName === orderDetails[index].state && location) {
              setOrderDetails((prevOrderDetails) =>
                prevOrderDetails.map((item, idx) => {
                  if (idx === index && normalizedStateName === item.state && location) {
                    return {
                      ...item,
                      streetAddress: formattedAddress,
                      coordinates: [location.lng(), location.lat()],
                    };
                  }
                  return item;
                })
              );
            } else {
              showToast({
                toastText: `Selected place is not in ${orderDetails[index].state}.`,
                isSuccess: false,
              });
            }
          };

          autocomplete.addListener("place_changed", handlePlaceSelect);
          autocompleteInstances.push(autocomplete);
        }
      });
    });

    return () => {
      autocompleteInstances.forEach((instance) => {
        window.google.maps.event.clearInstanceListeners(instance);
      });
    };
  }, [googleLoader, orderDetails.length, orderDetails.map((od) => od.state).join(",")]);

  const handleAddOrder = () => {
    const newOrderDetail = {
      customerName: "",
      phoneNumber: "",
      email: "",
      items: [],
      boxes: [],
      deliveryType: "",
      deliveryDate: "",
      streetAddress: "",
      coordinates: [],
      state: "",
      LGA: "",
      landmark: "",
      recipientName: "",
      paymentType: "",
      orderComment: "",
      lgaOptions: [],
      originalLgaOptions: [],
      lgaLoading: false,
    };

    setOrderDetails((prevOrderDetails) => {
      const updatedOrderDetails = [...prevOrderDetails, newOrderDetail];
      const newIndex = updatedOrderDetails.length - 1;
      const selectedState = deliveryStates.find((state) => state.name === newOrderDetail.state);
      if (selectedState) {
        getOrderDeliveryLGAs(
          selectedState.id,
          showToast,
          updatedOrderDetails,
          setOrderDetails,
          newIndex,
          (isLoading) => setLgaLoadingForIndex(newIndex, isLoading)
        );
      }
      return updatedOrderDetails;
    });

    setPopoverStates((states) => [
      ...states,
      { isVisible: false, searchProduct: "", loading: false },
    ]);
    setPopoverStates2((states) => [...states, { isVisible: false, loading: false }]);
  };

  const handleSearchChange = (searchProduct, index) => {
    // Update the search product in the corresponding popover state
    setPopoverStates((current) =>
      current.map((item, idx) => (idx === index ? { ...item, searchProduct } : item))
    );
  };

  const handleRemoveOrder = (index) => {
    const updatedOrderDetails = [...orderDetails];
    updatedOrderDetails.splice(index, 1);
    setOrderDetails(updatedOrderDetails);
  };

  const handleChange = (index, event) => {
    const { name, type, checked, value } = event.target;
    const isCheckbox = type === "checkbox";

    const updatedOrderDetails = orderDetails.map((item, idx) => {
      if (idx !== index) return item;

      // If state is changed, reset the LGA and streetAddress
      if (name === "state") {
        return {
          ...item,
          [name]: value,
          lga: "", // optionally clear LGA too
          streetAddress: "",
        };
      }

      return {
        ...item,
        [name]: isCheckbox ? checked : value,
      };
    });

    setOrderDetails(updatedOrderDetails);

    // If the state field is changed, update the corresponding LGA options
    if (name === "state") {
      const selectedState = deliveryStates.find((state) => state.name === value);
      if (selectedState) {
        getOrderDeliveryLGAs(
          selectedState.id,
          showToast,
          updatedOrderDetails,
          setOrderDetails,
          index,
          (isLoading) => setLgaLoadingForIndex(index, isLoading)
        );
      }
    }
  };

  const handleInputChange = (index, inputValue, actionMeta) => {
    if (actionMeta.action === "input-change") {
      const currentOrderDetail = orderDetails[index];
      const filteredLgas = currentOrderDetail.originalLgaOptions.filter((lga) =>
        lga.label.toLowerCase().includes(inputValue.toLowerCase())
      );

      let newLgaOptions;
      if (filteredLgas.length === 0 && inputValue.trim() !== "") {
        newLgaOptions = [
          {
            value: "comingSoon",
            label: `We are coming to ${inputValue} soon! Join our waitlist and be the first to know when we do.`,
          },
        ];
      } else {
        newLgaOptions = filteredLgas;
      }

      const updatedOrderDetails = orderDetails.map((detail, idx) =>
        idx === index ? { ...detail, lgaOptions: newLgaOptions } : detail
      );

      setOrderDetails(updatedOrderDetails);
    }
  };

  const handleSelectChange = (index, selectedOption) => {
    setOrderDetails((prevOrderDetails) =>
      prevOrderDetails.map((detail, idx) => {
        if (idx === index) {
          let newDetail = {
            ...detail,
            LGA: selectedOption
              ? selectedOption.value !== "comingSoon"
                ? selectedOption.value
                : ""
              : "",
          };

          if (selectedOption?.value === "comingSoon") {
            // Show the modal for "coming soon"
            setShowWaitlist(true);

            // Update LGA options dynamically
            const selectedState = deliveryStates.find((state) => state.name === newDetail.state);
            if (selectedState) {
              getOrderDeliveryLGAs(
                selectedState.id,
                showToast,
                prevOrderDetails,
                setOrderDetails,
                index,
                (isLoading) => setLgaLoadingForIndex(index, isLoading)
              );
            } else {
              console.error(`State '${newDetail.state}' not found in deliveryStates.`);
            }
          }

          return newDetail;
        }
        return detail;
      })
    );
  };

  const formatOptionLabel = ({ label, value }) => {
    if (value === "comingSoon") {
      // Split the label to insert styling on a specific part
      const firstPart = "We are coming to ";
      const secondPart = label.split("soon! ")[0].replace(firstPart, "");
      const thirdPart = "soon! ";
      const actionPart = "Join our waitlist and be the first to know when we do.";

      return (
        <div>
          {firstPart}
          <span>{secondPart}</span>
          {thirdPart}
          <span style={{ textDecoration: "underline", color: "#469B12 " }}>{actionPart}</span>
        </div>
      );
    }
    // Return the label as is for other options
    return label;
  };

  const isNigerianPhoneNumber = (phoneNumber) => {
    // This regex matches phone numbers starting with '070', '080', '090', '081', and '091'
    return /^0[7-9][0-1]\d{8}$/.test(phoneNumber) || /^091\d{8}$/.test(phoneNumber);
  };

  const handleTogglePopover = (index) => {
    const newStates = [...popoverStates];
    newStates[index].isVisible = !newStates[index].isVisible;
    setPopoverStates(newStates);
  };

  const handleTogglePopover2 = (index) => {
    const newStates = [...popoverStates2];
    newStates[index].isVisible = !newStates[index].isVisible;
    setPopoverStates2(newStates);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleToggleItem = (productId, index) => {
    const product = globalProducts.find((p) => p.id === productId);
    if (!product) {
      showToast({ toastText: "Product not found.", isSuccess: false });
      return;
    }

    if (product?.stockLevel === "out_of_stock" || product?.quantityAvailable === 0) {
      showToast({ toastText: "This product is out of stock.", isSuccess: false });
      return;
    }

    const orderDetail = orderDetails[index];
    const itemIndex = orderDetail.items.findIndex((item) => item.productId === productId);

    if (itemIndex !== -1) {
      // Item exists, remove it
      const newItems = [...orderDetail.items];
      newItems.splice(itemIndex, 1);
      const newOrderDetails = [...orderDetails];
      newOrderDetails[index] = { ...orderDetail, items: newItems };
      setOrderDetails(newOrderDetails);
    } else {
      // Item does not exist, add it
      const newItem = {
        productId: productId,
        name: product.productName,
        quantity: 1,
        price: product.price,
        size: product.size,
      };
      const newOrderDetails = [...orderDetails];
      newOrderDetails[index] = { ...orderDetail, items: [...orderDetail.items, newItem] };
      setOrderDetails(newOrderDetails);
    }
  };

  const handleToggleItem2 = (id, index) => {
    const box = globalSubscriptions.find((p) => p._id === id);
    if (!box) {
      showToast({ toastText: "Box not found.", isSuccess: false });
      return;
    }

    const orderDetail = orderDetails[index];
    const itemIndex = orderDetail.boxes.findIndex((item) => item.id === id);

    if (itemIndex !== -1) {
      // Item exists, remove it
      const newBoxes = [...orderDetail.boxes];
      newBoxes.splice(itemIndex, 1);
      const newOrderDetails = [...orderDetails];
      newOrderDetails[index] = { ...orderDetail, boxes: newBoxes };
      setOrderDetails(newOrderDetails);
    } else {
      // Item does not exist, add it
      const newBox = {
        id: id,
        name: box.name,
        quantity: 1,
        amount: box.amount,
      };
      const newOrderDetails = [...orderDetails];
      newOrderDetails[index] = { ...orderDetail, boxes: [...orderDetail.boxes, newBox] };
      setOrderDetails(newOrderDetails);
    }
  };

  const handleChangeQuantity = (productId, delta, index) => {
    const product = globalProducts.find((p) => p.id === productId);
    if (!product) {
      showToast({ toastText: "Product not found.", isSuccess: false });
      return;
    }

    const orderDetail = orderDetails[index];
    const itemIndex = orderDetail.items.findIndex((item) => item.productId === productId);

    if (itemIndex === -1) {
      showToast({ toastText: "Item not found in order.", isSuccess: false });
      return;
    }

    const item = orderDetail.items[itemIndex];
    const newQuantity = item.quantity + delta;

    if (newQuantity <= 0) {
      // If quantity falls to zero or less, remove item
      handleToggleItem(productId, index);
      return;
    }

    if (newQuantity > product.quantityAvailable) {
      showToast({
        toastText: `Only ${product.quantityAvailable} items in stock.`,
        isSuccess: false,
      });
      return;
    }

    // Update quantity
    const newItems = [...orderDetail.items];
    newItems[itemIndex] = { ...item, quantity: newQuantity };
    const newOrderDetails = [...orderDetails];
    newOrderDetails[index] = { ...orderDetail, items: newItems };
    setOrderDetails(newOrderDetails);
  };

  const handleChangeQuantity2 = (id, delta, index) => {
    const box = globalSubscriptions.find((p) => p._id === id);
    if (!box) {
      showToast({ toastText: "Box not found.", isSuccess: false });
      return;
    }

    const orderDetail = orderDetails[index];
    const itemIndex = orderDetail.boxes.findIndex((item) => item.id === id);

    if (itemIndex === -1) {
      showToast({ toastText: "Item not found in order.", isSuccess: false });
      return;
    }

    const item = orderDetail.boxes[itemIndex];
    const newQuantity = item.quantity + delta;

    if (newQuantity <= 0) {
      // If quantity falls to zero or less, remove item
      handleToggleItem2(id, index);
      return;
    }

    // Update quantity
    const newBoxes = [...orderDetail.boxes];
    newBoxes[itemIndex] = { ...item, quantity: newQuantity };
    const newOrderDetails = [...orderDetails];
    newOrderDetails[index] = { ...orderDetail, boxes: newBoxes };
    setOrderDetails(newOrderDetails);
  };
  const isFormValid = () => {
    for (let order of orderDetails) {
      // Check if required fields are missing or invalid
      if (
        !order?.customerName ||
        !order?.phoneNumber ||
        !order?.email ||
        (!order?.items.length && !order?.boxes.length) || // Both cannot be empty
        !order?.deliveryType ||
        !order?.deliveryDate ||
        !order?.paymentType ||
        (order?.deliveryType === "delivery" &&
          (!order?.streetAddress || !order?.state || !order?.LGA || !order?.landmark))
      ) {
        return false;
      }
    }
    return true;
  };

  const handleSave = (e) => {
    e.preventDefault();

    const minimumOrderAmount = 12000;
    let isAnyOrderBelowMinimum = false;

    orderDetails.forEach((detail, index) => {
      let totalPrice =
        (detail.items || []).reduce((acc, item) => acc + item.quantity * item.price, 0) +
        (detail.boxes || []).reduce((acc, box) => acc + box.quantity * box.price, 0);

      if (totalPrice < minimumOrderAmount) {
        const amountLeftToAdd = minimumOrderAmount - totalPrice;
        showToast({
          toastText: `Add items worth at least ₦${amountLeftToAdd} to reach the ₦12,000 minimum basket amount for Order ${index + 1}.`,
          isSuccess: false,
        });
        isAnyOrderBelowMinimum = true;
      }
    });

    if (isAnyOrderBelowMinimum) {
      return;
    }

    const validationErrors = orderDetails.map((detail, index) => {
      const errors = {};

      if (!detail.phoneNumber) {
        errors.phoneNumber = "Please enter your Phone Number";
      } else if (detail.phoneNumber.length !== 11) {
        errors.phoneNumber = "Please enter a valid 11-digit Nigerian phone number";
      }

      if (!detail.email) {
        errors.email = "Email is required";
      }

      return errors;
    });

    setError(validationErrors);

    if (validationErrors.some((errors) => Object.keys(errors).length > 0)) {
      return;
    }

    const newOrders = orderDetails.map((detail) => {
      const selectedState = deliveryStates.find((state) => state.name === detail.state);
      const stateId = selectedState ? selectedState.id : null;

      const selectedLGA = detail.lgaOptions.find((option) => option.label === detail.LGA);
      const lgaId = selectedLGA ? selectedLGA.id : null;
      const orderBody = {
        deliveryDate: new Date(`${detail.deliveryDate.split("T")[0]}T12:00:00`).toISOString(),
        carts: [
          ...(detail.items?.length > 0
            ? detail.items.map((item) => ({
                productId: item.productId,
                quantity: item.quantity,
              }))
            : []),
          ...(detail.boxes?.length > 0
            ? detail.boxes.map((box) => ({
                box: box.id,
                quantity: box.quantity,
              }))
            : []),
        ],

        phoneNumber: detail.phoneNumber,
        deliveryType: detail.deliveryType,
        deliverySchedule: "scheduled",
        paymentMethod: detail.paymentType,
      };

      if (detail.deliveryType !== "pickup") {
        orderBody.address = {
          streetAddress: detail?.streetAddress,
          city: lgaId,
          state: stateId,
          landmark: detail?.landmark,
          location: {
            type: "Point",
            coordinates: detail?.coordinates || [0, 0], // fallback if missing
          },
        };
      }

      if (detail?.orderComment !== "") {
        orderBody.orderComment = detail?.orderComment;
      }
      if (detail?.recipientName !== "") {
        orderBody.recipientName = detail?.recipientName;
      }

      return {
        ...orderBody,
        userName: detail.customerName,
        email: detail.email,
      };
    });

    createOrder({ newOrders }, setLoading, showToast);
  };

  return (
    <div>
      <div className="d-flex gap-3 align-items-center  header-admin  py-4 pe-5 mb-4 ps-4">
        <img src={arrowLeft} onClick={handleBack} alt="arrow" />
        <h3 style={{ color: "#344054" }} className="my-auto">
          Create Order
        </h3>
      </div>
      <div className=" pe-5 ps-4 ">
        <Form onSubmit={handleSave}>
          {orderDetails.map((orderDetail, index) => {
            const orderTotal =
              (orderDetail?.items || []).reduce(
                (acc, item) => acc + (Number(item.quantity) || 0) * (Number(item.price) || 0),
                0
              ) +
              (orderDetail?.boxes || []).reduce(
                (acc, box) => acc + (Number(box.quantity) || 0) * (Number(box.amount) || 0),
                0
              );
            return (
            <Card
              className="border-0 px-4 pt-4 mb-"
              style={{ boxShadow: "0px 1px 2px 0px #0000001A", borderRadius: "8px" }}
              key={index}
            >
              {orderDetails.length > 1 && (
                <div className="d-flex justify-content-end mb-4">
                  <CloseButton onClick={() => handleRemoveOrder(index)} />
                </div>
              )}

              <Row className="">
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Customer's Name<sup className="text-danger">*</sup>
                  </p>
                  <Form.Control
                    type="text"
                    name="customerName"
                    value={orderDetail?.customerName}
                    onChange={(e) => handleChange(index, e)}
                    placeholder="Enter name"
                    required
                  />
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Recipient Name (if different from sender)
                  </p>
                  <Form.Control
                    type="text"
                    name="recipientName"
                    value={orderDetail?.recipientName}
                    onChange={(e) => handleChange(index, e)}
                  />
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Phone Number<sup className="text-danger">*</sup>
                  </p>
                  <Form.Control
                    name="phoneNumber"
                    type="text"
                    placeholder="Enter phone number"
                    value={orderDetail?.phoneNumber}
                    onChange={(event) => {
                      const numericValue = event.target.value.replace(/\D/g, "");
                      if (numericValue.length <= 11) {
                        const updatedOrderDetails = orderDetails?.map((item, idx) =>
                          idx === index ? { ...item, phoneNumber: numericValue } : item
                        );
                        setOrderDetails(updatedOrderDetails);
                      }

                      // Error handling (could be handled better in context with actual data)
                      if (numericValue.length === 11 && !isNigerianPhoneNumber(numericValue)) {
                        setError({
                          ...error,
                          phoneNumber: "Please enter a valid 11-digit Nigerian phone number.",
                        });
                      } else {
                        setError({ ...error, phoneNumber: "" });
                      }
                    }}
                  />
                  {error.phoneNumber && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                      {error.phoneNumber}
                    </div>
                  )}
                </Col>

                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Email address<sup className="text-danger">*</sup>
                  </p>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={orderDetail?.email}
                    onChange={(e) => handleChange(index, e)}
                    required
                  />
                  {error.email && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                      {error.email}
                    </div>
                  )}
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Items <sup className="text-danger">*</sup>
                  </p>
                  <div
                    onClick={() => handleTogglePopover(index)}
                    ref={popoverRefs.current[index]}
                    style={{
                      cursor: "pointer",
                      border: "1px solid #ced4da",
                      borderRadius: "8px",
                      padding: "0.35rem 0.75rem",
                      minHeight: "38px",
                      gap: "5px",
                    }}
                    className="d-flex align-items-center"
                  >
                    {orderDetail?.items?.length > 0 && <i className="bi bi-plus-lg"></i>}{" "}
                    <div className="item-container">
                      {orderDetail?.items?.length > 0 ? (
                        orderDetail?.items?.map((item) => (
                          <Button
                            variant="outline-secondary"
                            style={{
                              color: "#11142D",
                              border: "1px solid #E7E8EA",
                              fontWeight: "500",
                              fontSize: "11px",
                              boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.03)",
                            }}
                            key={item.productId}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent popover from toggling
                              handleToggleItem(item.productId, index);
                            }}
                          >
                            {item?.name} {item?.size ? ` - ${item?.size}` : ""} (`QTY:$
                            {item.quantity}) &nbsp; X
                          </Button>
                        ))
                      ) : (
                        <span className="text-muted">Add items</span>
                      )}
                    </div>
                  </div>

                  <Overlay
                    show={popoverStates[index] && popoverStates[index].isVisible}
                    target={popoverRefs.current[index]}
                    placement="bottom"
                    rootClose={true}
                    onHide={() => handleTogglePopover(index)}
                  >
                    {popoverStates[index] && (
                      <Popover
                        id={`popover-basic-${index}`}
                        className="custom-popover"
                        style={{ width: "430px" }}
                      >
                        <Popover.Body>
                          <div className="d-flex align-items-center position-relative py-1 px-1 mb-3">
                            {popoverStates[index].searchProduct !== "" && (
                              <i
                                className="bi bi-x"
                                style={{
                                  top: "5%",
                                  right: "1.5%",
                                  position: "absolute",
                                  fontSize: "1.5rem",
                                  color: "#98A2B3",
                                }}
                                onClick={() => handleSearchChange("", index)}
                              ></i>
                            )}
                            <Form.Control
                              style={{
                                border: "1px solid #E1E6EF",
                                backgroundColor: "#E1E6EF",
                                borderRadius: "3px",
                                fontWeight: "500",
                              }}
                              placeholder="Search by product name"
                              value={popoverStates[index]?.searchProduct}
                              onChange={(e) => handleSearchChange(e.target.value, index)}
                              autoFocus
                            />
                          </div>
                          {productsLoading ? (
                            <div
                              className="justify-content-center align-items-center text-center"
                              style={{ padding: "150px" }}
                            >
                              <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          ) : globalProducts?.length > 0 ? (
                            <>
                              <div style={{ borderTop: "1px solid #E1E6EF" }} className="pb-2 pt-3">
                                <h5 className="" style={{ fontWeight: "500" }}>
                                  Items{" "}
                                </h5>
                              </div>
                              <ListGroup
                                style={{ maxHeight: "300px", overflowY: "scroll", border: "none" }}
                                className="no-border-listgroup"
                              >
                                {globalProducts.map((product) => {
                                  const selectedItem = orderDetails[index]?.items?.find(
                                    (item) => item?.productId === product?.id
                                  );
                                  return (
                                    <ListGroup.Item
                                      key={product.id}
                                      action
                                      className="d-flex justify-content-between"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        label={`${product?.productName} ${product?.size ? ` - ${product?.size}` : ""} - ₦${product?.price?.toLocaleString()}`}
                                        checked={!!selectedItem}
                                        onChange={() => handleToggleItem(product.id, index)}
                                      />
                                      {selectedItem && (
                                        <div className="btn-group btn-group-sm">
                                          <Button
                                            onClick={() =>
                                              handleChangeQuantity(product.id, -1, index)
                                            }
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            -
                                          </Button>
                                          <Button
                                            variant="white"
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {selectedItem.quantity}
                                          </Button>
                                          <Button
                                            onClick={() =>
                                              handleChangeQuantity(product.id, 1, index)
                                            }
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            +
                                          </Button>
                                        </div>
                                      )}
                                    </ListGroup.Item>
                                  );
                                })}
                              </ListGroup>
                            </>
                          ) : searchPerformed && globalProducts.length === 0 ? (
                            <div className="fw-medium " style={{ padding: "50px 0" }}>
                              <h4 className="mb-2">No products found</h4>
                              <Button onClick={() => setSearchProduct("")}>
                                View all products
                              </Button>
                            </div>
                          ) : (
                            <div className="fw-medium " style={{ padding: "50px 0" }}>
                              <h4>You have no products</h4>
                            </div>
                          )}
                        </Popover.Body>
                      </Popover>
                    )}
                  </Overlay>
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Food Boxes
                  </p>
                  <div
                    onClick={() => handleTogglePopover2(index)}
                    ref={popoverRefs2.current[index]}
                    style={{
                      cursor: "pointer",
                      border: "1px solid #ced4da",
                      borderRadius: "8px",
                      padding: "0.35rem 0.75rem",
                      minHeight: "38px",
                      gap: "5px",
                    }}
                    className="d-flex align-items-center"
                  >
                    {orderDetail?.boxes?.length > 0 && <i className="bi bi-plus-lg"></i>}{" "}
                    <div className="item-container">
                      {orderDetail?.boxes?.length > 0 ? (
                        orderDetail?.boxes?.map((box) => (
                          <Button
                            variant="outline-secondary"
                            style={{
                              color: "#11142D",
                              border: "1px solid #E7E8EA",
                              fontWeight: "500",
                              fontSize: "11px",
                              boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.03)",
                            }}
                            key={box.id}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent popover from toggling
                              handleToggleItem2(box.id, index);
                            }}
                          >
                            {box.name} (`QTY:${box.quantity}) &nbsp; X
                          </Button>
                        ))
                      ) : (
                        <span className="text-muted">Add boxes</span>
                      )}
                    </div>
                  </div>

                  <Overlay
                    show={popoverStates2[index] && popoverStates2[index].isVisible}
                    target={popoverRefs2.current[index]}
                    placement="bottom"
                    rootClose={true}
                    onHide={() => handleTogglePopover2(index)}
                  >
                    {popoverStates2[index] && (
                      <Popover
                        id={`popover-basic-${index}`}
                        className="custom-popover"
                        style={{ width: "430px" }}
                      >
                        <Popover.Body>
                          {boxesLoading ? (
                            <div
                              className="justify-content-center align-items-center text-center"
                              style={{ padding: "150px" }}
                            >
                              <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          ) : globalSubscriptions?.length > 0 ? (
                            <>
                              <div style={{ borderTop: "1px solid #E1E6EF" }} className="pb-2 pt-3">
                                <h5 className="" style={{ fontWeight: "500" }}>
                                  Boxes{" "}
                                </h5>
                              </div>
                              <ListGroup
                                style={{ maxHeight: "300px", overflowY: "scroll", border: "none" }}
                                className="no-border-listgroup"
                              >
                                {globalSubscriptions.map((product) => {
                                  const selectedBox = orderDetails[index]?.boxes?.find(
                                    (box) => box?.id === product?._id
                                  );
                                  return (
                                    <ListGroup.Item
                                      key={product._id}
                                      action
                                      className="d-flex justify-content-between"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        label={`${product.name} - ₦${product?.amount?.toLocaleString()}`}
                                        checked={!!selectedBox}
                                        onChange={() => handleToggleItem2(product._id, index)}
                                      />
                                      {selectedBox && (
                                        <div className="btn-group btn-group-sm">
                                          <Button
                                            onClick={() =>
                                              handleChangeQuantity2(product._id, -1, index)
                                            }
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            -
                                          </Button>
                                          <Button
                                            variant="white"
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {selectedBox.quantity}
                                          </Button>
                                          <Button
                                            onClick={() =>
                                              handleChangeQuantity2(product._id, 1, index)
                                            }
                                            className="px-1 py-0 d-flex text-center align-items-center justify-content-center"
                                            style={{
                                              width: "1.5rem",
                                              height: "30px",
                                              fontWeight: "600",
                                            }}
                                          >
                                            +
                                          </Button>
                                        </div>
                                      )}
                                    </ListGroup.Item>
                                  );
                                })}
                              </ListGroup>
                            </>
                          ) : (
                            <div className="fw-medium " style={{ padding: "50px 0" }}>
                              <h4>You have no boxes</h4>
                            </div>
                          )}
                        </Popover.Body>
                      </Popover>
                    )}
                  </Overlay>
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Delivery Type <sup className="text-danger">*</sup>
                  </p>
                  <Form.Select
                    className="custom-select"
                    onChange={(e) => handleChange(index, e)}
                    value={orderDetail?.deliveryType}
                    name="deliveryType"
                    required
                  >
                    {" "}
                    <option value="" disabled>
                      Select delivery type
                    </option>
                    <option value="pickup">In-store pickup</option>
                    <option value="delivery">Home delivery</option>
                  </Form.Select>
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Delivery/Pickup Date<sup className="text-danger">*</sup>
                  </p>
                  <div className="custom-select-wrapper">
                    <Form.Select
                      className="custom-select"
                      onChange={(e) => handleChange(index, e)}
                      value={orderDetail?.deliveryDate}
                      name="deliveryDate"
                      required
                    >
                      {" "}
                      <option value="" disabled>
                        Select a date
                      </option>
                      {selectOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                    <FaRegCalendarAlt className="select-icon" /> {/* Calendar icon */}
                  </div>
                </Col>

                {orderDetail?.deliveryType === "delivery" && (
                  <>
                    <Col xs={4} className="px-2 mb-5">
                      <p
                        style={{ color: "#333333", fontWeight: "500" }}
                        className="pb-0 mb-1 d-flex align-items-center gap-2"
                      >
                        State <sup className="text-danger">*</sup>
                        {statesLoading && (
                          <span
                            className="spinner-border spinner-border-sm text-success ms-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </span>
                        )}
                      </p>
                      <Form.Select
                        className="custom-select"
                        onChange={(e) => handleChange(index, e)}
                        value={orderDetail?.state}
                        name="state"
                        disabled={statesLoading}
                      >
                        {" "}
                        <option value="" disabled>
                          {statesLoading ? "Loading states..." : "Select a state"}
                        </option>
                        {deliveryStates.map((state, index) => (
                          <option value={state?.name} key={index}>
                            {state?.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col xs={4} className="px-2 mb-5">
                      <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                        LGA<sup className="text-danger">*</sup> (Please select a state first)
                      </p>
                      <Select
                        formatOptionLabel={formatOptionLabel}
                        options={orderDetail?.lgaOptions} // Refer to lgaOptions within the current orderDetail
                        onInputChange={(inputValue, actionMeta) =>
                          handleInputChange(index, inputValue, actionMeta)
                        }
                        onChange={(selectedOption) => handleSelectChange(index, selectedOption)}
                        value={
                          orderDetail?.lgaOptions?.find(
                            (option) => option?.value === orderDetail?.LGA
                          ) || null
                        }
                        name="LGA"
                        isClearable={true}
                        isLoading={orderDetail?.lgaLoading}
                        loadingMessage={() => "Loading LGAs..."}
                        placeholder={orderDetail?.lgaLoading ? "Loading LGAs..." : "Select..."}
                      />
                    </Col>
                    <Col xs={4} className="px-2 mb-5">
                      <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                        Street Address (Please select state first){" "}
                        <sup className="text-danger">*</sup>
                      </p>
                      <div className="input-group">
                        <Form.Control
                          type="text"
                          name="streetAddress"
                          value={orderDetail?.streetAddress}
                          ref={streetAddressRefs.current[index]}
                          onChange={(e) => handleChange(index, e)}
                          placeholder="Enter Street Address"
                        />

                        {orderDetail?.streetAddress && (
                          <i
                            className="bi bi-x"
                            onClick={() => {
                              const updatedOrderDetails = orderDetails.map((item, idx) =>
                                idx === index ? { ...item, streetAddress: "" } : item
                              );
                              setOrderDetails(updatedOrderDetails);
                            }}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              top: "10%",
                              right: "10px",
                              zIndex: 100,
                              fontSize: "1.5rem",
                            }}
                          ></i>
                        )}
                      </div>
                      {error.streetAddress && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {error.streetAddress}
                        </div>
                      )}
                    </Col>
                    <Col xs={4} className="px-2 mb-5">
                      <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                        Landmark<sup className="text-danger">*</sup>
                      </p>
                      <Form.Control
                        type="text"
                        name="landmark"
                        value={orderDetail?.landmark}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </Col>
                  </>
                )}
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Comment
                  </p>
                  <Form.Control
                    type="text"
                    name="orderComment"
                    value={orderDetail?.orderComment}
                    onChange={(e) => handleChange(index, e)}
                  />
                </Col>

                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Payment Type <sup className="text-danger">*</sup>
                  </p>
                  <Form.Select
                    className="custom-select"
                    onChange={(e) => handleChange(index, e)}
                    value={orderDetail?.paymentType}
                    name="paymentType"
                    required
                  >
                    {" "}
                    <option value="" disabled>
                      Select payment type
                    </option>
                    <option value="Direct Transfer">Direct Transfer</option>
                  </Form.Select>
                </Col>
                <Col xs={4} className="px-2 mb-5">
                  <p style={{ color: "#333333", fontWeight: "500" }} className="pb-0 mb-1">
                    Total Amount
                  </p>
                  <Form.Control
                    type="text"
                    readOnly
                    value={`₦${orderTotal.toLocaleString()}`}
                    style={{ backgroundColor: "#F6F6F6", fontWeight: "600", color: "#11142D" }}
                  />
                </Col>
              </Row>
            </Card>
            );
          })}
          <div className="d-flex gap-3 mt-3" onClick={handleAddOrder}>
            <i className="bi bi-plus" style={{ color: "#469B12" }}></i>
            <p style={{ color: "#469B12", fontWeight: "500", textDecoration: "underline" }}>
              Add More
            </p>
          </div>

          <div className="pt-3 my-5 d-flex justify-content-end">
            <Button
              className="px-5 py-2"
              disabled={!isFormValid()}
              style={{
                backgroundColor: isFormValid() ? " #469B12" : "rgba(70, 155, 18, 0.2)",
                color: "#F6F6F6",
                boxShadow: "0px 4px 4px 0px #0E35BF40",
              }}
              type="submit"
            >
              Save
            </Button>
          </div>
        </Form>
      </div>
      <Waitlist showWaitlist={showWaitlist} setShowWaitlist={setShowWaitlist} />
    </div>
  );
};

export default CreateOrder;
